import React from "react";
import {
  InputOTP,
  InputOTPGroup,
  InputOTPSlot,
} from "@/components/ui/input-otp";

interface OTPInputProps {
  otp: string;
  setFieldValue: (field: string, value: any) => void;
  className?: string;
}

const OTPInput: React.FC<OTPInputProps> = ({ otp, setFieldValue, className }) => {
  const handleOtpChange = (value: string) => {
    setFieldValue("otp", value);
    
    // Auto submit when all 4 digits are entered
    if (value.length === 4) {
      // Find the form element and submit it
      setTimeout(() => {
        const form = document.querySelector("form");
        if (form) {
          form.requestSubmit();
        }
      }, 100);
    }
  };

  return (
    <div className={className}>
      <InputOTP
        maxLength={4}
        value={otp}
        onChange={handleOtpChange}
        className="w-full"
      >
        <InputOTPGroup className="flex gap-3 w-full">
          <InputOTPSlot 
            index={0} 
            className="flex-1 h-12 w-12 text-lg font-medium rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 focus:ring-2 focus:ring-indigo-500 focus:border-transparent" 
          />
          <InputOTPSlot 
            index={1} 
            className="flex-1 h-12 w-12 text-lg font-medium rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 focus:ring-2 focus:ring-indigo-500 focus:border-transparent" 
          />
          <InputOTPSlot 
            index={2} 
            className="flex-1 h-12 w-12 text-lg font-medium rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 focus:ring-2 focus:ring-indigo-500 focus:border-transparent" 
          />
          <InputOTPSlot 
            index={3} 
            className="flex-1 h-12 w-12 text-lg font-medium rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 focus:ring-2 focus:ring-indigo-500 focus:border-transparent" 
          />
        </InputOTPGroup>
      </InputOTP>
    </div>
  );
};

export default OTPInput;
